import { Component } from '@angular/core';
import { LoadingService } from 'src/app/services/loading-service';

@Component({
  selector: 'upsc-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  
  loading$ = this.loadingService.loading$;
  constructor(private loadingService: LoadingService) {}
}
